let isStoreSelected = false;

export function setIsStoreSelected(v) {
  isStoreSelected = !!v;
}

export function getIsStoreSelected() {
  return isStoreSelected;
}
